import React, { Component } from "react"
import { FilterStore, SelectionManager, compose, PhotoItemContainer, ImagePreview } from "@albelli/photoselector"
import { ContainerListView } from "@albelli/list-view-react"

import trackScrolling from "../../Scrolling"
import SelectionButtons from "../../Components/SelectionButtons"
import NavigateBack from "../../Components/NavigateBack"
import withRequest from "../../Http/withRequest"
import Filters from "../../Components/Filters"
import SortingSelector from "../../Components/SortingSelector"
import { PhotoOrganiserItem } from "../../Components/CategoryItemContainer"
import { ShowSimilar } from "../../Overlays"

interface EventProps {
  items: PhotoOrganiserItem[]
  totalItemsCount: number
  title: string
  store: SelectionManager
  navigateTo: () => void
  sortingDirection: string
  getItems: () => void
  getSimilarsPhotos: (id: string, callback: () => void) => void
  handleSortingChange: (comp: any, e: any) => void
}

class Event extends Component<EventProps, {}> {
  private scrollHandler: (ev: any) => void = trackScrolling(this)

  constructor(props: EventProps) {
    super(props)
    FilterStore.register(this)
  }

  render() {
    const itemSize = FilterStore.getItemSize()
    const layout = FilterStore.getLayouts(itemSize)
    const { navigateTo, title, totalItemsCount, getItems, sortingDirection, items, handleSortingChange } = this.props
    const bulkAdapter = () => this.props.items

    return (
      <>
        <NavigateBack navigateTo={navigateTo} title={title} />
        <SelectionButtons store={this.props.store} getItems={getItems} totalItemsCount={totalItemsCount} items={items} />

        {items.length > 0 && (
          <Filters store={FilterStore}>
            <SortingSelector sortingDirection={sortingDirection} handleSortingChange={handleSortingChange} />
          </Filters>
        )}

        <ContainerListView className="photo-organiser-image-container" layout={layout} items={items} onScroll={this.scrollHandler}>
          {(item) => {
            const phoroOrganiserItem = item as PhotoOrganiserItem
            return (
              <PhotoItemContainer item={phoroOrganiserItem} store={this.props.store} bulkAdapter={bulkAdapter}>
                <ShowSimilar
                  similarCount={phoroOrganiserItem.similarCount}
                  onClick={(event) => {
                    this.props.getSimilarsPhotos(item.id, () => {
                      /* IGNORE */
                    })
                    event.stopPropagation()
                  }}
                />
                <ImagePreview item={phoroOrganiserItem} getItems={bulkAdapter} store={this.props.store} />
              </PhotoItemContainer>
            )
          }}
        </ContainerListView>
      </>
    )
  }
}

export default compose(withRequest)(Event)
